import { render } from "./CarouselComponent.vue?vue&type=template&id=4c83de17&scoped=true"
import script from "./CarouselComponent.vue?vue&type=script&lang=js"
export * from "./CarouselComponent.vue?vue&type=script&lang=js"

import "./CarouselComponent.vue?vue&type=style&index=0&id=4c83de17&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c83de17"]])

export default __exports__